// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3mG-4","content":"LayoutSettings_content__uQWPd"};